import { Component, OnInit, Inject,ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-energy-monitoring',
  templateUrl: './energy-monitoring.component.html',
  styleUrls: ['./energy-monitoring.component.css',
  '../animate.css/animate.min.css',
  "../aos/aos.css",
  "../bootstrap/css/bootstrap.min.css",
  "../bootstrap-icons/bootstrap-icons.css",
  "../boxicons/css/boxicons.min.css",
  "../glightbox/css/glightbox.min.css",
  "../remixicon/remixicon.css",
  "../swiper/swiper-bundle.min.css",
  "../style.css"],
  encapsulation: ViewEncapsulation.None ,
  providers: [NgbCarouselConfig] 
})
export class EnergyMonitoringComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  SlideOptions3 = { items: 5, margin: 10, dots: true, nav: true,mouseDrag: true,
    touchDrag: true,pullDrag: true,autoplay:true,responsive: {
      0: {
        items: 1
      },
      300: {
        items: 3
      },
      400: {
        items: 3
      },
      740: {
        items: 3
      },
      940: {
        items: 5
      }
      },
    };  

    Images1 = [
      {title: "Level Monitoring",text: "", img: "assets/img/blue_bor_search.svg",button: "#about"},
      {title: "Take Data-Driven Decision",text: "", img: "assets/img/blue_bor_takedata.svg",button: "#about"},
      {title: "Flow Monitoring",text: "", img: "assets/img/blue_bor_flowmonitor.svg",button: "#about"},
      {title: "2-way communication",text: "", img: "assets/img/2way_communication.svg",button: "#about"},
      {title: "Remote Device Configuration",text: "", img: "assets/img/remote_device.svg",button: "#about"},
      {title: "MQIT Support",text: "", img: "assets/img/mqit.svg",button: "#about"},
      {title: "Easy to install and operate",text: "", img: "assets/img/easyoperater.svg",button: "#about"},
      {title: "End to End IIoT Solution",text: "", img: "assets/img/endsolution.svg",button: "#about"},
      {title: "Real Time Monitoring and Alert",text: "", img: "assets/img/realtime.svg",button: "#about"},
      {title: "Advance Data Analytics",text: "", img: "assets/img/advancedata.svg",button: "#about"},
      {title: "Past Data Access",text: "", img: "assets/img/pastdata.svg",button: "#about"},
      {title: "Allows remote controlling of pumps",text: "", img: "assets/img/allowremote.svg",button: "#about"},
      {title: "Role wise Portal Access",text: "", img: "assets/img/rolewise.svg",button: "#about"},
      {title: "Hierarchical Access",text: "", img: "assets/img/portalmeter.svg",button: "#about"},
  ];  

  SlideOptions2 = { items: 5, margin: 10, dots: true, nav: true,mouseDrag: true,
    touchDrag: true,pullDrag: true,autoplay:true,responsive: {
        0: {
          items: 1
        },
        300: {
          items: 3
        },
        400: {
          items: 3
        },
        740: {
          items: 3
        },
        940: {
          items: 5
        }
      },
    };  

    Images2 = [
      {title: "Automation",img: "assets/img/automation.svg"},
      {title: "Manufacturing Plants",img: "assets/img/Manufacturing Plants.svg"},
      {title: "Waterwaste Management",img: "assets/img/oilgas.svg"},
      {title: "Rubber",img: "assets/img/rubber.svg"},
      {title: "Automotive and Aircraft",img: "assets/img/Solar.svg"},
      {title: "Paint",img: "assets/img/paint.svg"},
      {title: "Pulp and Paper Mills",img: "assets/img/pulp.svg"},
      {title: "Waste Water Treatment Plants",img: "assets/img/wastewatertreatment.svg"},
      {title: "Beverage water",img: "assets/img/beverage.svg"},
      {title: "Dairy Industry",img: "assets/img/dairy.svg"},
      {title: "Textile manufacturing",img: "assets/img/textile.svg"},
      {title: "Glass",img: "assets/img/glass.svg"},
      {title: "Metal Production",img: "assets/img/metal.svg"},
      {title: "Chemical Plants",img: "assets/img/chemical.svg"},
      {title: "Semiconductor Industry",img: "assets/img/semiconducter_industries.svg"},
      {title: "Irrigation Systems",img: "assets/img/irrigation_systems.svg"},
  ];  

  navigateenergymonitoring(){
    this.router.navigate(['energymonitoring'])
  }

  navigatecontact(){
    this.router.navigate(['contact'])
  }

}
